<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isGoodsDetailLoading">
      <div class="info-card">
        <el-tabs v-model="activeTabName">
          <el-tab-pane label="商品详情" name="first"></el-tab-pane>
          <el-tab-pane :label="'评论('+firstForm.formResult.total+')'" name="second"></el-tab-pane>
        </el-tabs>
        <div v-if="activeTabName === 'first'">
          <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="editGoods">编辑</el-button>
          <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" />
        </div>
        <wt-form-table v-if="secondCreate" v-show="activeTabName === 'second'" :form.sync="firstForm" >
          <wt-form-table-list ref="evalTableRef" slot="wtFormTableList" :form.sync="firstForm">
             <template slot="score" slot-scope="data">
              <el-rate v-model="data.row.score" disabled></el-rate>
             </template>
           </wt-form-table-list>
        </wt-form-table>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <wt-detail-page  :visible.sync="editObj.visible" :component-name="editComponentName" component-type="edit" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Goods-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_GOODS',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/goods/goodsUpdate',
      formAddUrl: '/modules/goods/goodsAdd',
      detailFormButtons: {
        title: '商品详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '商品编号', key: 'goodsNo', type: 'text', disabled: true },
          { name: '商品标题', key: 'title', type: 'text', disabled: true },
          { name: '商品副标题', key: 'subtitle', type: 'text', disabled: true },
          { name: '商品积分', key: 'integral', type: 'text', disabled: true },
          { name: '商品类型', key: 'typeName', type: 'text', disabled: true },
          { name: '商品库存', key: 'inventory', type: 'text', disabled: true },
          { name: '商品图片', key: 'coverList', type: 'image', disabled: true },
          { name: '商品介绍', key: 'content', type: 'editor', disabled: true }]
      },
      activeTabName: 'first',
      firstForm: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_USERMESSAGE',
        formComponent: {
          list: { type: 'default', value: '/modules/goodsEvaluation/goodsEvaluationList' },
          delete: { type: 'default', value: '/modules/goodsEvaluation/goodsEvaluationDelete' }
        },
        formInputsData: [{ name: 'goodsId', key: 'goodsId', value: '', type: 'customAll' },
          { name: 'evaluation', key: 'evaluation', value: '', type: 'customAll' },
          { name: 'keyWord', key: 'keyWord', value: '', type: 'customAll' },
          { name: 'updateTimeRange', key: 'updateTimeRange', value: [], type: 'customAll' }],
        formButtonsData: [],
        formTableData: [
          { name: '评论', key: 'evaluation', type: 'text' },
          { name: '评价星级', key: 'score', type: 'custom' },
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '评论时间', key: 'createTime', type: 'text' }],
        formTableButtonsData: [{ name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: true }
      },
      editComponentName: 'Goods-edit',
      editObj: {
        visible: false
      },
      secondCreate: false
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    editGoods() {
      this.editObj.visible = true
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isGoodsDetailLoading: state => state.goods.isGoodsDetailLoading,
      detailFormData: state => state.goods.goodsDetailData
    })
  },
  watch: {
    isGoodsDetailLoading(val) {
      if (!val) {
        this.firstForm.formInputsData[0].value = this.detailFormData.id
        this.secondCreate = true
        if (this.detailFormData.cover && this.detailFormData.cover.length > 0) {
          const _coverList = this.detailFormData.cover.split(',')
          this.detailFormData.coverList = []
          for (const item of _coverList) {
            this.detailFormData.coverList.push({ fileUrl: item })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.info-card {
  padding: 20px;
  background: #fff;
}
</style>
